function Camera(app) {

	this.videoEl;

	this.p = app;

	this._hasStream = false;

	this.cameraResolution = {
		// width: 1920,
		// height: 1080
		width: 1280,
		height: 720
	}

	// Create the video element
	this.videoEl = document.createElement('video');
	this.videoEl.id = 'webcam-video';
	this.videoEl.setAttribute("crossOrigin", "Anonymous");
	this.videoEl.width = this.cameraResolution.width;
	this.videoEl.height = this.cameraResolution.height;
	$("#container").append(this.videoEl);

	var constraints = {
		audio: false,
		video: {
			width: {min: this.cameraResolution.width},
			height: {min: this.cameraResolution.height}
		}
	};

	navigator.getUserMedia(constraints,
		jQuery.proxy(this.onCameraAvailable, this),
		jQuery.proxy(this.onCameraUnavailable, this)
	);
}

Camera.prototype.onCameraAvailable = function (stream) {
	var url = window.URL;
	this.videoEl.src = url.createObjectURL(stream);
	this.videoEl.play();
	this.p.initRecorder(stream);
}

Camera.prototype.onCameraUnavailable = function (e) {
	console.log("error");
	console.log(e);
}

Camera.prototype.play = function () {
	if (this.hasStream()) {
		this.videoEl.play();
	}
}

Camera.prototype.pause = function () {
	if (this.hasStream()) {
		this.videoEl.pause();
	}
}

Camera.prototype.ended = function () {
	if (this.hasStream()) {
		this.isEnded = true;
	}
}

Camera.prototype.reset = function () {
	if (this.hasStream()) {
		this.isEnded = false;
		this.pause();
		this.videoEl.currentTime = 0;
	}
}

Camera.prototype.hasStream = function () {
	if (this._hasStream) {
		return true;
	} else if (this.videoEl.readyState === this.videoEl.HAVE_ENOUGH_DATA) {
		this._hasStream = true;
		return true;
	}
}

Camera.prototype.isPlaying = function () {
	if (this.hasStream()) {
		return !this.videoEl.paused;
	}
	return false;
}

// Expose App
window.Camera = Camera;